<div *ngIf="demoDataAvailable" class="container" fxLayout="column" fxLayoutAlign="space-around">


    <div fxLayout="column" fxLayoutAlign="center center">

        <div class="top-part" fxLayout="column" fxLayoutAlign="center center">       
            <div class="top-text">
                <b>Congratulations</b> on completing your free diagnostic exam!
            </div>     
            <button 
                class="button secondary-button rpt-button"  
                [routerLink]="['/ELearning/CurriculumDiagnosticReport/' + demoResultData.StudentConsumerCurriculumID]">
                Free Diagnostic Report
            </button>

            <div class="upgrade-text">
                <h2>
                    Upgrade to Unlock Your Learning Potential
                </h2>
                <div class="hr-line">
                    <hr>
                </div>
            </div>
            
        </div>

        

        <div id="content-desktop">
            <table>
                <col><col><col>
                <thead>
                    <tr>    
                        <td></td>
    
                        <td>
                            <div class="basic" fxLayout="column" fxLayoutAlign="center center">
                                <div class="price-bubble bubble-basic" fxLayout="row" fxLayoutAlign="center center">
                                    {{demoResultData.BasicPrice | numberToCurrency}}
                                </div>
                                <div class="level-title" >
                                    Ascend Basic
                                </div>
                            </div>
                            
                        </td> 
        
                        <td  > 
                            <div class="full" fxLayout="column" fxLayoutAlign="center center">
                                <div class="price-bubble bubble-full" fxLayout="row" fxLayoutAlign="center center">
                                    {{demoResultData.FullPrice | numberToCurrency}}
                                </div>
                                <div class="level-title">    
                                    Ascend Premium
                                </div>
                            </div>
                            
                        </td>
                    </tr>
                </thead>
        
                <tbody>
                    <tr>  
                        <td>
                            <b>Diagnostic Tests</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(1)">more info</span>
                        </td>
                        <td>
                            <b>1</b>
                        </td>
                        <td>
                            <b>Unlimited</b>
                        </td>
                    </tr>
        
                    <tr>  
                        <td>
                            <b>Individualized Lesson Maps</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(2)">more info</span>
                        </td>
                        <td  class="">
                            <b>1</b>
                        </td>
                        <td  class="">
                            <b>Unlimited</b>
                        </td>
                    </tr>
    
                    <tr>  
                        <td>
                            <b>Personalized On-Demand Lessons</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(3)">more info</span>
                        </td>
                        
                        <td>
                            <b>15</b>
                        </td>
        
                        <td>
                            <b>{{totalLessons}}+</b>
                        </td>
                    </tr>
    
                    <tr>  
                        <td>
                            <b>Remediation Approach</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(4)">more info</span>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
    
                    <tr>  
                        <td>
                            <b>Extensive Approach</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(5)">more info</span>
                        </td>
        
                        <td>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
    
                    <tr *ngIf="demoResultData.UnitTestsAvailable">  
                        <td>
                            <b>Unit Tests</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(6)">more info</span>
                        </td>
        
                        <td>
                            
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
        
                    <tr>  
                        <td>
                            <b>Achievements Tracking</b>
                            <br>
                            <span class="moreinfo" (click)="getMoreInfo(7)">more info</span>
                        </td>
        
                        <td>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
                    
                    <tr>  
                        <td>
                            <b>Access to Entire Course</b>
                        </td>
        
                        <td>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
    
                    <tr class="nobackground">  
                        <td class="nohover">
                            
                        </td>
                        <td class="nohover">
                            <button class="buynow basic" (click)="buyBasic()">Upgrade Now!</button>
                        </td>
                        <td class="nohover">
                            <button class="buynow full" (click)="buyFull()">Upgrade Now!</button>                       
                        </td>
                    </tr>
                    
                </tbody>
            </table>
        </div>

        <div id="content-mobile">
            <table>
                <col><col>
                <thead>
                    <tr>    

                        <td>
                            <div class="basic" fxLayout="column" fxLayoutAlign="center center">
                                <div class="price-bubble bubble-basic" fxLayout="row" fxLayoutAlign="center center">
                                    {{demoResultData.BasicPrice | numberToCurrency}}
                                </div>
                                <div class="level-title" >
                                    Ascend Basic
                                </div>
                            </div>
                            
                        </td> 
        
                        <td  > 
                            <div class="full" fxLayout="column" fxLayoutAlign="center center">
                                <div class="price-bubble bubble-full" fxLayout="row" fxLayoutAlign="center center">
                                    {{demoResultData.FullPrice | numberToCurrency}}
                                </div>
                                <div class="level-title">    
                                    Ascend Premium
                                </div>
                            </div>
                            
                        </td>
                    </tr>
                </thead>
        
                <tbody>
                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Diagnostic Tests</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(1)">more info</span>
                            <hr>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>1</b>
                        </td>
                        <td>
                            <b>Unlimited</b>
                        </td>
                    </tr>
        
                    
                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Individualized Lesson Maps</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(2)">more info</span>
                            <hr>
                        </td>
                    </tr>
                    <tr>
                        <td  class="">
                            <b>1</b>
                        </td>
                        <td  class="">
                            <b>Unlimited</b>
                        </td>
                    </tr>

                    
                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Personalized On-Demand Lessons</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(3)">more info</span>
                            <hr>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>15</b>
                        </td>
        
                        <td>
                            <b>{{totalLessons}}+</b>
                        </td>
                    </tr>

                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Remediation Approach</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(4)">more info</span>
                            <hr>
                        </td>
                    </tr>
                    <tr>    
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>

                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Extensive Approach</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(5)">more info</span>
                            <hr>
                        </td>
                    </tr>
                    <tr> 
                        <td>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>

                    <tr class="nohover"  *ngIf="demoResultData.UnitTestsAvailable">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Unit Tests</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(6)">more info</span>
                            <hr>
                        </td>
                    </tr>
                    <tr> 
                        <td>
                            
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Achievements Tracking</b>
                            </div>
                            <span class="moreinfo" (click)="getMoreInfo(7)">more info</span>
                            <hr>
                        </td>
                    </tr>
        
                    <tr>      
                        <td>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>
                    <tr class="nohover">
                        <td colspan="2">
                            <div class="row-headers">
                                <b>Access to Entire Course</b>
                            </div>
                            <hr>
                        </td>
                    </tr>
                    
                    <tr>      
                        <td>
                        </td>
        
                        <td>
                            <i class="fas fa-check "></i>
                        </td>
                    </tr>

                    <tr class="nobackground">  
                        <td class="nohover">
                            <button class="buynow basic" (click)="buyBasic()">Upgrade to Ascend Basic Now!</button>
                        </td>
                        <td class="nohover">
                            <button class="buynow full" (click)="buyFull()">Upgrade to Ascend Premium Now!</button>                       
                        </td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
                
    </div>

</div>


<div *ngIf="!demoDataAvailable" class="spinner-wrapper">
    <div fxLayout="column">
      <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    </div>
  </div>

<!-- <div *ngIf="demoDataAvailable != null && !demoDataAvailable">No Diagnostic Exam data could be found.</div> -->
